import React, { Component } from "react";
import { connect } from "react-redux";
import SalesDate from "./sales/SalesDate";
import SalesPills from "./sales/SalesPills";
import moment from "moment";
import {
	filterMyPassengers,
	filterMyPassengersStatements,
	requestUserProgramFidelity
} from "../../actions/passengers";
import Select from "../../../shared/Select/Select";
import Loading from "../../../shared/Loading/Loading";
// import { getValMinMilesByNationalFidelity } from "../../../shared/utils";
import { getFidelitiesFromSales } from "../../shared/requests-api";
import Panel from "../../../shared/Panel/Panel";
import PanelHeader from "../../../shared/Panel/PanelHeader";
import { withGetScreen } from "react-getscreen";
import { SCREEN_BREAKPOINT } from "../../shared/screen-breakpoints";
import PanelContent from "../../../shared/Panel/PanelContent";
import BoxMessageInfo from "../../../shared/BoxMessageInfo/BoxMessageInfo";
import MyPassengersNotFound from "./template/MyPassengersNotFound";
import MyPassengersLogList from "./template/MyPassengersLogList";
import MyPassengersTotalizersHeader from "./template/my-passengers-totalizers-header/MyPassengersTotalizersHeader";
import { getAllFidelityPlans } from "../../actions/util";
import MyPassengersHasError from "./template/MyPassengersHasError";
import { intFormat } from "../../../../js/shared/utils";

class MyPassengers extends Component {
	constructor(props) {
		super(props);

		this.state = {
			excludeAvianca: true
		};
	}

	renderPassengers = () => {
		const { fetchingSales, errorSales, data, filteredStatements } = this.props;

		if (fetchingSales) {
			return (
				<div className="my-passengers__loading">
					<Loading />
				</div>
			);
		}

		if (errorSales) {
			return <MyPassengersHasError />;
		}

		if (data.logs.length > 0) {
			return (
				<div className="my-passengers__panel__content--data">
					<MyPassengersTotalizersHeader
						passengers={data.countPassengers}
						totalMiles={data.totalMiles}
						totalValue={data.totalValue}
						countReductionsUsed={data.countReductionsUsed}
						programId={filteredStatements.programId}
					/>
					<MyPassengersLogList logs={data.logs} fidelityPlan={filteredStatements.programId} />
				</div>
			);
		}

		return <MyPassengersNotFound />;
	};

	handleChangeSelect = selected => {
		this.filterMyPassengers({ programId: selected.value }, true);
	};

	filterMyPassengers = (filteredStatements, instantSearch = false) => {
		this.props.filterMyPassengersStatements(
			this.props.filteredStatements,
			filteredStatements,
			instantSearch
		);
	};

	componentDidMount() {
		const { requestUserProgramFidelity } = this.props;
		requestUserProgramFidelity();
		this.filterMyPassengers(this.props.filteredStatements, true);
	}

	render() {
		const { data, isMobile, isTablet, programs, filteredStatements, fetchingSales } = this.props;
		const { excludeAvianca } = this.state;

		return (
			<Panel className="my-passengers__panel">
				<PanelHeader className="my-passengers__panel__header">
					<h1>MEUS PASSAGEIROS</h1>
					<span>
						Acompanhe o vôo dos passageiros que estão viajando com suas milhas por programa de
						fidelidade.
					</span>
					{fetchingSales ? (
						<>
							<Loading />
						</>
					) : (
						<>
							<div className="my-passengers__panel__header--fidelities-plans">
								{isMobile() || isTablet() ? (
									<Select
										selected={programs.reduce(
											(selected, item) => {
												if (item.id === filteredStatements.programId) {
													selected = {
														value: item.id,
														label: item.name,
														valMinMiles: item.valMinMiles
													};
												}

												return selected;
											},
											{ label: "Selecione" }
										)}
										options={
											excludeAvianca
												? programs
													.filter(program => program.id != 6)
													.reduce((newListPrograms = [], program) => {
														return newListPrograms.concat({
															value: program.id,
															label: program.name,
															valMinMiles: program.valMinMiles
														});
													}, [])
												: programs.reduce((newListPrograms = [], program) => {
													return newListPrograms.concat({
														value: program.id,
														label: program.name,
														valMinMiles: program.valMinMiles
													});
												}, [])
										}
										onChange={this.handleChangeSelect}
										data-action="sales-passengers-fidelity-select"
									/>
								) : (
									<SalesPills
										programs={programs}
										selectedProgramId={filteredStatements.programId}
										handleClick={this.filterMyPassengers}
										isDisabled={this.props.fetchingSales}
										excludeAvianca={excludeAvianca}
									/>
								)}
							</div>
						</>
					)}
				</PanelHeader>
				<PanelContent className="my-passengers__panel__content">
					<div className="my-passengers__panel__content--info-filters">
						<BoxMessageInfo
							renderStatement={
								data.logs.length > 0 &&
								data.logs[0].averageMiles &&
								filteredStatements.programId === 3
							}
						>
							{data.logs[0] && data.logs[0].averageMiles && (
								<p>
									Média atual: {intFormat(data.logs[0].averageMiles)} milhas por passageiro{" "}
									<small>
										(definida em {moment(data.logs[0].entryDate).format("DD/MM/YYYY")} às{" "}
										{moment(data.logs[0].entryDate).format("HH:mm")})
									</small>
								</p>
							)}
						</BoxMessageInfo>
						<SalesDate
							selectedProgramId={filteredStatements.programId}
							dateChanged={this.filterMyPassengers}
							startDate={this.props.filteredStatements.startDate}
							endDate={this.props.filteredStatements.endDate}
							isDisabled={this.props.fetchingSales}
						/>
					</div>

					{this.renderPassengers()}
				</PanelContent>
			</Panel>
		);
	}
}

const mapStateToProps = state => {
	return {
		...state.myPassengers
	};
};

const mapDispatchToProps = {
	filterMyPassengers,
	filterMyPassengersStatements,
	requestUserProgramFidelity,
	getAllFidelityPlans
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(
	withGetScreen(MyPassengers, {
		mobileLimit: SCREEN_BREAKPOINT.sm,
		tabletLimit: SCREEN_BREAKPOINT.lg,
		shouldListenOnResize: true
	})
);
